.header_WelcomeHeader_1018d57{display:flex;justify-content:center;background-color:var(--primary-color-1)}.header_WelcomeHeader_1018d57>svg{filter:invert(1)}